import { _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { cacheZipFile } from '../../component-pdf-viewer';
import { svrtsRequest } from '../../svrts-interface';
import { PromptConfirm } from '../confirm';
export const downloadNotes = (rs) => {
    PromptConfirm({
        msg: `Are you sure you want to download all ${rs.props.notes.length} notes?`,
        yes: cb => {
            svrtsRequest({
                data: {
                    funcID: [0, 66],
                    notes: _(rs.props.notes)
                        .map(x => ({
                        id: x.ID,
                        title: x.Title ?? '',
                        bodyText: x.Note ?? '',
                        attachment: x.Attachment ?? null,
                    }))
                        .value(),
                },
                no: data => {
                    cb(data.message);
                },
                yes: data => {
                    cacheZipFile(data.hashCode, data.zipFileData, data.filename, url => {
                        cb(true);
                        Alerts.DownloadReady({
                            title: 'Notes Download Ready',
                            msg: `Your notes file "${data.filename}" is ready. Click "Open File" to open it.`,
                            url: url,
                            filename: data.filename,
                        });
                    });
                },
            });
        },
    });
};
//# sourceMappingURL=download.js.map